import React, { useEffect, useState } from "react";
import built0 from '../assets/images/built-0.webp';
import built1 from '../assets/images/built-1.webp';
import built1Line from '../assets/images/built-1-line.webp';
import built2 from '../assets/images/built-2.webp';
import built2Line from '../assets/images/built-2-line.webp';
import built3 from '../assets/images/built-3.webp';
import built3Line from '../assets/images/built-3-line.webp';
import built4 from '../assets/images/built-4.webp';
import built4Line from '../assets/images/built-4-line.webp';
import startBuildingUFO from '../assets/images/start-building-ufo.webp';
import startBuildingCoin from '../assets/images/start-building-coins.webp';
import litepaperButton1 from '../assets/images/litepaper-button-1.webp';
import litepaperButton1Hover from '../assets/images/litepaper-button-1-hover.webp';
import litepaperButton2 from '../assets/images/litepaper-button-2.webp';
import litepaperButton2Hover from '../assets/images/litepaper-button-2-hover.webp';
import litepaperDashboardBottom from '../assets/images/litepaper-dashboard-bottom.webp';
import litepaperDashboardTop from '../assets/images/litepaper-dashboard-top.webp';
import litepaperTextbox from '../assets/images/litepaper-textbox.webp';
import litepaperMoon from '../assets/images/litepaper-moon.webp';
import iconCopy from '../assets/images/icon-copy.svg';
import iconExternalLink from '../assets/images/icon-external-link.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function Build() {

  const [currentBuilt, setCurrentBuilt] = useState('');

  const builtHover = (zook) => {
    setCurrentBuilt(zook);
  }

  const copyCode = () => {
    navigator.clipboard.writeText('npm install candy-sdk');
    toast.success('Code copied!');
  }

  return (
    <div id="build" className="">
      <ToastContainer theme='dark' />
      <section id='built-for-web3'>
        <div className='marquee pt-10'>
          <ul className='marquee__content'>
            <li><span className='circle'>⬤</span>Built for Web3 Gaming</li>
            <li><span className='circle'>⬤</span>Built for Web3 Gaming</li>
            <li><span className='circle'>⬤</span>Built for Web3 Gaming</li>
          </ul>
          {/* <!-- Mirrors the content above --> */}
          <ul className='marquee__content' aria-hidden='true'>
            <li><span className='circle'>⬤</span>Built for Web3 Gaming</li>
            <li><span className='circle'>⬤</span>Built for Web3 Gaming</li>
            <li><span className='circle'>⬤</span>Built for Web3 Gaming</li>
          </ul>
        </div>

        <div>
          <div className='button-groups flex flex-wrap md:flex-nowrap gap-4 w-full justify-center pt-20 relative z-10 px-5'>
            <button className='btn btn-purple-shadow animate-gradient lg:w-[200px] md:w-[25%]' onMouseEnter={() => builtHover('zook-1')} onMouseLeave={() => builtHover('')}>
              Scale Your Game
            </button>
            <button className='btn btn-purple-shadow animate-gradient lg:w-[200px] md:w-[25%]' onMouseEnter={() => builtHover('zook-2')} onMouseLeave={() => builtHover('')}>
              Onboard Players Effortlessly
            </button>
            <button className='btn btn-purple-shadow animate-gradient lg:w-[200px] md:w-[25%]' onMouseEnter={() => builtHover('zook-3')} onMouseLeave={() => builtHover('')}>
              Build <br />Faster
            </button>
            <button className='btn btn-purple-shadow animate-gradient lg:w-[200px] md:w-[25%]' onMouseEnter={() => builtHover('zook-4')} onMouseLeave={() => builtHover('')}>
              Enhance <br /> Your Gaming Experience
            </button>
          </div>

          <div className={`zook-action ${currentBuilt}`}>
            <div className="zook zook-default">
              <div className="zook-text">
                <div className="main-text">
                  Built for Web3 Gaming
                </div>
              </div>
              <img src={built0} alt='Zook Default' />
            </div>
            <div className='zook zook-1'>
              <div className='zook-text'>
                <div className='main-text text-right'>Scale Your <br />Games</div>
                <div className='sub-text text-right'>
                  Break free from Ethereum's limitations. ZKcandy delivers the speed and scalability your games need, all while keeping fees low and accessible for every player.
                </div>
              </div>
              <img className='zook-line' src={built1Line} alt='Zook Description' />
              <img src={built1} alt='Zook' />
            </div>
            <div className='zook zook-2'>
              <div className='zook-text'>
                <div className='main-text text-right'>Onboard Players <br />Effortlessly</div>
                <div className='sub-text text-right'>
                  Welcome players with open arms. Candy Passport streamlines onboarding, replacing complex wallet setups with user-friendly logins through Abstraction.
                </div>
              </div>
              <img className='zook-line' src={built2Line} alt='Zook Description' />
              <img src={built2} alt='Zook' />
            </div>
            <div className='zook zook-3'>
              <div className='zook-text'>
                <div className='main-text text-left'>Build <br />Faster</div>
                <div className='sub-text text-left'>
                  Seamlessly integrate NFTs and blockchain features into your games with our intuitive Candy API. Spend less time on tech, more time on crafting unforgettable experiences.
                </div>
              </div>
              <img className='zook-line' src={built3Line} alt='Zook Description' />
              <img src={built3} alt='Zook' />
            </div>
            <div className='zook zook-4'>
              <div className='zook-text'>
                <div className='main-text text-right'>Enhance Your Gaming <br />Experience</div>
                <div className='sub-text text-left'>
                  Give players the freedom they deserve. With sponsored gas fees and gas abstraction-assisted flexible token payment options, your games become more accessible and enjoyable for everyone.
                </div>
              </div>
              <img className='zook-line' src={built4Line} alt='Zook Description' />
              <img src={built4} alt='Zook' />
            </div>
          </div>
        </div>
      </section>

      <section id='start-building' className='flex justify-center items-center flex-col p-10'>
        <div className='relative'>
          <img className='absolute -left-[10%] md:w-[200px] w-[90px] md:-top-[23svh] -top-[15svh]' src={startBuildingCoin} alt='Space Element' />
          <img className='absolute translate-x-[-50%] left-[50%] md:-top-[23svh] -top-[15svh]' src={startBuildingUFO} alt='Space Element' />
          <img className='absolute -right-[10%] md:w-[200px] w-[90px] scale-x-[-1] md:-top-[23svh] -top-[15svh]' src={startBuildingCoin} alt='Space Element' />

          <div className='title font-black md:text-[4rem] text-[1.8rem] text-white uppercase relative'>
            Start Building
          </div>

          <div className='code flex justify-between items-center w-full max-w-[600px] mt-5 cursor-pointer relative' onClick={copyCode}>
            <div className='uppercase md:text-[1rem] text-[.7rem]'>npm install candy-sdk</div>
            <img src={iconCopy} className='md:w-[20px] w-[12px]' alt='Copy Button' />
          </div>

          <div className="grid grid-cols-2 w-full gap-5 mt-5 max-w-[600px] md:h-[200px] h-[150px] relative">
            <a href='https://docs.zkcandyapi.com/' target='_blank' rel="noreferrer" className="code flex flex-col justify-between">
              <img className='ms-auto md:w-[18px] w-[10px]' src={iconExternalLink} alt='Hyperlink' />
              <div className='uppercase md:text-[1rem] text-[.7rem]'>Docs</div>
            </a>
            <a href='https://app.zkcandyapi.com/login' target='_blank' rel="noreferrer" className="code flex flex-col justify-between">
              <img className='ms-auto md:w-[18px] w-[10px]' src={iconExternalLink} alt='Hyperlink' />
              <div className='uppercase md:text-[1rem] text-[.7rem]'>Go No Code</div>
            </a>
          </div>
        </div>
      </section>

      <section id="litepaper" className="relative">
        <div className="max-w-[2000px] mx-auto relative">
          <img className="absolute md:top-[-40px] top-[-20px] w-full" src={litepaperDashboardTop} alt="Litepaper Dashboard" />

          <div className="flex justify-center items-center absolute -translate-y-1/2 top-[29%] -translate-x-1/2 left-1/2 z-10">
            <div className="litepaper-text 2xl:max-w-[650px] xl:max-w-[450px] lg:max-w-[400px] md:max-w-[300px] max-w-[160px] relative flex flex-col items-center justify-center">
              <img src={litepaperMoon} className="w-[80px] md:w-[140px] lg:w-[210px] xl:w-[250px] absolute" alt="Litepaper" />
              <img src={litepaperTextbox} className="relative" alt="Litepaper" />
            </div>
          </div>
          <div className="relative xl:pt-60 pt-40">
            <img src={litepaperDashboardBottom} className="w-full" alt="Litepaper Dashboard" />
            <a href='/litepaper/index.html' target='_blank' rel="noreferrer" className="litepaper-button absolute bottom-[15%] md:bottom-[19.5%] lg:bottom-[21.5%] xl:bottom-[20%] 2xl:bottom-[22%] left-[40.7%] w-[17%] -translate-x-1/2">
              <img src={litepaperButton1} alt="Litepaper" className="magenta absolute top-0 z-2 w-full" />
              <img src={litepaperButton1Hover} alt="Litepaper" className="w-full" />
            </a>
            <a href='https://docs.zkcandyapi.com/' target='_blank' rel="noreferrer" className="litepaper-button absolute bottom-[15%] md:bottom-[19.5%] lg:bottom-[21.5%] xl:bottom-[20%] 2xl:bottom-[22%] right-[24%] w-[17%] -translate-x-1/2">
              <img src={litepaperButton2} alt="Litepaper" className="magenta absolute top-0 z-2 w-full" />
              <img src={litepaperButton2Hover} alt="Litepaper" className="w-full" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}